import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      longTablePart: state => state.stat.longTablePart,
      commType: state => state.stat.activeType
    })
  },

  methods: {
    isShow(tableId) {
      return !this.longTablePart ||
        (this.longTablePart && this.longTablePart === tableId)
    }
  }
}
